import { render } from "./VideoTam.vue?vue&type=template&id=2b235ea3"
import script from "./VideoTam.vue?vue&type=script&lang=js"
export * from "./VideoTam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__